'use client';
import { Title, Button, Icon, Text, InputForm } from '@ui/components';
import { useForgotPasswordState, ForgotForm } from './forgot-password.state';
import Link from 'next/link';

interface IForgotPassword {
  onForgot(form: ForgotForm, errorCb: (e: string) => void): void;
  onLogin(): void;
}

export function ForgotPasswordComponentV2({ onLogin, onForgot }: IForgotPassword) {
  const { email, isLoading, onSubmit } = useForgotPasswordState(onForgot);
  return (
    <div className="flex h-full w-full flex-col justify-between">
      <div className="w-full h-fit m-auto">
        <Title type="l" className="mb-4 text-center lg:text-left">
          Password Recovery
        </Title>
        <Text type="m" className="mb-6 block text-center lg:mb-10 lg:text-left">
          If you can&apos;t remember your password, we can send you an email with a link to reset it
        </Text>

        <div className="mb-10">
          <InputForm label="Email" form={email} disabled={isLoading} />
        </div>

        <Button type="primary" className="w-full" onClick={onSubmit} isLoading={isLoading}>
          Reset Password
        </Button>
        <Text type="m" className="text-center mt-4">
          <span>Go back to </span>
          <Link href="/auth/login" className="cursor-pointer text-[#FF6600] font-semibold">
            Sign In
          </Link>
        </Text>
      </div>
    </div>
  );
}
